import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PleasewaitPopup } from "../../../../components/PleasewaitPopup";
import { baseURL } from "../../../../config/api";
import useAuth from "../../../../hook/useAuth";

export const AddVendorStatus = () => {
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const [statusName, setStatusName] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWaitPopup(true);

        await axios
            .post(
                `${baseURL}statuses?userId=${auth?.id}`,
                JSON.stringify({
                    attributeName: "vendor",
                    statusValue: statusName,
                    description
                }),
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: false,
                }
            )
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error("Error:", error);
            });
    }

    return (
        <>
            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className="w-full bg-white p-4 rounded-md">
                    <h2 className={`text-lg font-semibold`}>Add Vendor Status</h2>

                    <div className="mt-2 p-2">
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <div className="w-full">
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                                    <div>
                                        <label className="block text-xs font-medium text-secondary">Status Name</label>
                                        <input
                                            type="text"
                                            className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                            value={statusName}
                                            placeholder="Status Name"
                                            onChange={(e) => setStatusName(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-xs font-medium text-secondary">Description</label>
                                        <textarea
                                            rows={2}
                                            className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                            value={description}
                                            placeholder="Description"
                                            onChange={(e) => setDescription(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="flex flex-col sm:flex-row gap-4 mt-6">
                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>

                                    <button
                                        type="button"
                                        onClick={() => navigate(-1)}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>

    )
}